(function () {
    'use strict';
    EO_TimeRangeController.$inject = ['$scope', '$attrs', '$element'];

    function EO_TimeRangeController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.disableEndTime = false;

        if ($ctrl.lockEndTime != undefined && $ctrl.lockEndTime) {
            $ctrl.disableEndTime = true;
        }


        $scope.$watch('$ctrl.startTime', function () {

            if ($ctrl.duration && $ctrl.startTime) {
                $ctrl.endTime = moment($ctrl.startTime).add($ctrl.duration, 'm').toDate();
            }
            // if (momentTime && $ctrl.momentTime!=$ctrl.init_momentTime) {
            //     var hour = momentTime.split(":")[0].trim();
            //     var min = momentTime.split(":")[1].trim();
            //     $ctrl.timeValue = new Date(1970, 0, 1, hour, min, 0);
            //     if($ctrl.selectedTime)
            //         $ctrl.timeValue=$ctrl.selectedTime;
            //
            //
            // }
        });

    }


    var EO_TimeRange = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/time-range/eyeson.time-range.template.html',
        controller: EO_TimeRangeController,
        bindings: {
            startTime: '=',
            endTime: '=',
            duration: '=?',
            lockEndTime: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('eoTimeRange', EO_TimeRange)


})();

//angular.module('tikonApp').directive('eoTimeRange',['$timeout', function ($timeout) {
//        return {
//            restrict: 'E',
//            templateUrl: 'app/components/eyeson/time-range/eyeson.time-range.template.html',
//
//            //   template: '<input class="datePickerClass" />',
//            scope: {
//                startTime:'=',
//                endTime:'='
//
//
//            },
//            link: function (scope, element, attributes) {
//
//                var el = $(element);
//                scope.inited=false;
//
//
//                scope.$watch('startTime', function (timeValue) {
//              //     scope.slider.minValue=TimeToValue( timeValue);
//                 //  initSlider();
//                });
//                scope.$watch('endTime', function (timeValue) {
//               //     scope.slider.maxValue=TimeToValue( timeValue);
//                 //   initSlider();
//                });
//                function initSlider(){
//                    scope.dstartTime=TimeToValue(scope.startTime);
//                    scope.dendTime=TimeToValue(scope.endTime);
//                    if(scope.dendTime==0)scope.dendTime=24*60;
//                    $timeout(function(){
//                        scope.slider = {
//
//                            options: {
//                                floor: 0,
//                                ceil: 24*60,
//                                step:15,
//                                noSwitching: true,
//                                minRange: 120,
//                                from: 'white',
//                                to: '#FC0',
//                                showTicks: false,
//                                //id: value,
//                                onStart: function(id) {
//
//                                },
//                                onChange: function(id) {
//
//
//                                },
//                                onEnd: function(sliderId, modelValue, highValue, pointerType) {
//                                    scope.startTime=(ValueToTime(modelValue));
//                                    scope.endTime=(ValueToTime(highValue));
//                                    scope.$apply();
//
//                                },
//
//                                translate: function(value, sliderId, label) {
//                                  //  console.log(sliderId);
//                                    var intValue=value;
//                                    var hour= Math.floor( value/60);
//                                    var hourstr=hour;
//                                    if(hour<10)hourstr='0'+hourstr;
//                                    var min= value%60;
//                                    var minstr=min;
//                                    if(min<10)minstr='0'+minstr;
//                                    value= hourstr+':'+minstr;
//
//                                    switch (label) {
//                                        case 'model':
//
//                                           //this.startTime=ValueToTime(intValue);
//                                            return '<div style="text-align: center" ><b>ساعت شروع</b><br/> ' + value + "</div>";
//                                         break;
//                                        case 'high':
//                                            //this.endTime=ValueToTime(intValue);
//                                            return '<div style="text-align: center" ><b>ساعت پایان</b><br/> ' + value+"</div>";;
//                                        default:
//
//                                            return  value
//                                    }
//                                    return value;
//
//
//
//                                }
//                            }
//                        };
//
//
//
//                    },0);
//                    $timeout(function(){
//                        scope.inited=true;
//
//                        scope.$broadcast('rzSliderForceRender');
//
//
//                    },500);
//
//                }
//                function onRangeCanged()
//                {
//
//                    scope.$apply();
//                }
//                function ValueToTime(value)
//                {
//                    var hour= Math.floor( value/60);
//                    var min= value%60;
//                    return new Date(1970, 0, 1, hour, min, 0);
//
//                }
//                function  TimeToValue(timeValue)
//                {
//                    var timeValueStr =15;
//                    var temp = new Date(timeValue);
//                    if (temp != 'Invalid Date') {
//
//                        timeValueStr = temp.getHours()*60 + temp.getMinutes();
//                    }
//
//                    return timeValueStr
//                }
//            }
//        };
//    }]
//);
